<!-- Layout correspondiente a la parte privada. Todas las rutas que lo usen asumen mínimo que el usuario está autenticado -->
<template>
  <Menu @toggle-notificaciones="toggleNotificaciones"></Menu>
  <div class="container-fluid">
    <div class="row">
      <slot></slot>
    </div>
  </div>
  <NotificacionesPanel :isVisible="notificacionesVisible" @close-notificaciones="toggleNotificaciones"
    class="notificaciones-panel"></NotificacionesPanel>
</template>
<script setup lang="ts">
import Menu from "@/components/menu/Menu.vue";
import NotificacionesPanel from "@components/notificaciones/NotificacionesPanel.vue";
import { provide, ref } from "vue";
import { useVersionCheck } from "@composables/useVersionCheck";

const notificacionesVisible = ref(false);
const numNotificacionesSinLeer = provide('numNotificacionesSinLeer', ref(0));

useVersionCheck();

function toggleNotificaciones() {
  notificacionesVisible.value = !notificacionesVisible.value;
}
</script>
<style lang="scss" scoped>
.notificaciones-panel {
  top: 80px;
  border-radius: 10px 0 0 0;
}
</style>